import { render } from "./ProfileModalView.vue?vue&type=template&id=89980e46&scoped=true"
import script from "./ProfileModalView.vue?vue&type=script&lang=js"
export * from "./ProfileModalView.vue?vue&type=script&lang=js"

import "./ProfileModalView.vue?vue&type=style&index=0&id=89980e46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89980e46"]])

export default __exports__